export default Object.freeze({
  // AI_MODEL_DELETE: 'AI_MODEL_DELETE',
});
